import cn from 'classnames'
import Image from 'next/image'
import {FC} from 'react'
import {CircleFlag} from 'react-circle-flags'

import {theme} from '@/theme/theme'
import {Jurisdiction} from '@/utils/countries/constants'
import {getJurisdictionFlagSrc} from '@/utils/countries/flags'

type JurisdictionFlagProps = {
  jurisdiction: Jurisdiction | string
  size?: number
  isOutlined?: boolean
}

export const JurisdictionFlag: FC<JurisdictionFlagProps> = ({
  jurisdiction,
  size = 20,
  isOutlined = false,
}) => {
  // We want to use custom flags for jurisdictions we hold an asset for
  const flagSrc = getJurisdictionFlagSrc(jurisdiction)

  return (
    <>
      <div className={cn('wrapper', isOutlined && 'outline')}>
        {flagSrc ? (
          <Image src={flagSrc} alt={`${jurisdiction} flag`} width={size} height={size} />
        ) : (
          <CircleFlag countryCode={jurisdiction.toLowerCase()} height={size} />
        )}
      </div>

      <style jsx>{`
        .wrapper {
          position: relative;
          display: flex;
        }
        .outline {
          border-radius: 50%;
          box-shadow: 0px 0px 0px 1px ${theme.palette.gray[200]};
        }
      `}</style>
    </>
  )
}
